import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CommonService } from 'src/app/services/common/common.service';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { CompanyConstant } from 'src/app/constants/label-constants';
import { QuestionImage } from 'src/app/constants/message-constant';
import { commonErrorMessage, companyErrorPageMessage } from 'src/app/constants/error-message-constant';
@Component({
  selector: 'app-company-add-edit',
  templateUrl: './company-add-edit.component.html',
  styleUrls: ['./company-add-edit.component.scss']
})
export class CompanyAddEditComponent {
  files!: File;
  imageURL: any;
  filesPhoto: any[] | undefined;
  CompanyPhoto: any;
  CompanyForm: FormGroup = this.formBuilder.group({});
  companyId: number = 0;
  commonConstant: any = [];
  modalButton: boolean = false;
  submittedCompanydetail = false;
  CommonConstant: any = [];
  CompanyConstant: any = [];
  flag: boolean = false;
  companyLogo: string = '';
  errorMessage: any = [];
  commonErrorMessage: any = [];

  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.CompanyForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }

  constructor(
    private CommonService: CommonService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
    private toster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.CompanyConstant = CompanyConstant;
    this.commonConstant = CommonConstant;
    this.errorMessage = companyErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.onInitCompanyForm();
    if (this.companyId > 0) {
      this.getCompanyDetail(this.companyId);
    }
    else {
      this.spinner.hide()
      this.companyId = 0;
      this.flag = true;
    }
  }

  onInitCompanyForm() {
    this.CompanyForm = this.formBuilder.group({
      companyId: [0],
      CompanyName: ['', [Validators.required]],
      EmailId: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      MobileNo: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
      Address: ['', [Validators.required]],
      CompanyWebsite: ["", [Validators.required, Validators.pattern(/^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/)]],
      CompanyLogo: [''],
      CompanyAbout: ['', [Validators.required]],
      CompanyType: ['', [Validators.required]],
      CompanySize: ['', [Validators.required, Validators.pattern(/^(0|[1-9]\d*)(-(0|[1-9]\d*))?$/)]],
    });
  }

  get companyFormControl() {
    return this.CompanyForm.controls;
  }

  onCancel() {
    if (this.CompanyForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.UserForm = this.CompanyForm;
    }
    else {
      this.modalService.close();
    }
  }

  getCompanyDetail(companyId: number) {
    const apiUrl = this.apiUrl.apiUrl.company.GetCompanyById.replace("{id}", companyId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data.data) {
          this.imageURL = data.data.companyLogo ? data.data.companyLogo : '';
        }
        this.setCompanyForm(data.data);
        this.spinner.hide()
        this.flag = true;
      },
      error: (err) => {
        console.log('GetCompanyById-Error', err);
      }
    });
  }

  setCompanyForm(data) {
    this.CompanyForm.setValue({
      companyId: (data.companyId) ? data.companyId : 0,
      CompanyName: data.companyName,
      EmailId: data.emailId.toLowerCase(),
      MobileNo: data.mobileNo,
      Address: data.address.trim(),
      CompanyWebsite: data.companyWebsite,
      CompanyLogo: data.companyLogo ? data.companyLogo : '',
      CompanyAbout: (data.companyAbout) ? data.companyAbout : '',
      CompanyType: (data.companyType) ? data.companyType : '',
      CompanySize: (data.companySize) ? data.companySize : ''
    });
    this.companyLogo = data.companyLogo;
  }

  saveCompany() {
    this.submittedCompanydetail = true;
    this.modalButton = true;
    if (!this.CompanyForm.valid) {
      return;
    }
    this.spinner.show();
    const form = new FormData();
    form.append('companyId', this.CompanyForm.value.companyId ? this.CompanyForm.value.companyId.toString() : '0');
    form.append('companyName', this.CompanyForm.value.CompanyName.trim());
    form.append('companyWebsite', this.CompanyForm.value.CompanyWebsite.trim());
    form.append('emailId', this.CompanyForm.value.EmailId.toLowerCase().trim());
    form.append('mobileNo', this.CompanyForm.value.MobileNo.trim());
    form.append('address', this.CompanyForm.value.Address.trim());
    form.append("companyPhoto", this.files);
    form.append("companylogo", this.companyLogo);
    form.append('companyAbout', this.CompanyForm.value.CompanyAbout.trim());
    form.append('companyType', this.CompanyForm.value.CompanyType.trim());
    form.append('companySize', this.CompanyForm.value.CompanySize.trim());
    const apiUrl = this.apiUrl.apiUrl.company.SaveCompany;
    this.CommonService.doPost(apiUrl, form).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.modalService.close('save');
          this.toastr.success(data.message);
          this.spinner.hide();
        }
        else {
          this.toastr.error(data.message);
          this.spinner.hide();
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      if (this.commonConstant.FILEFORMAT.includes(event.target.files[0].type)) {
        this.files = event.target.files[0];
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.imageURL = reader.result;
        }
      }
      else {
        this.toster.error(QuestionImage.IMAGE_INVALID);
      }
    }
  }

  onDeSelectFile() {
    this.imageURL = "";
  }
}
